import React from 'react';
import {connect} from 'react-redux';
import axios from 'axios';  
import ReactHtmlParser from 'react-html-parser';
import * as apis from '../../constants/Apis';
import * as utils from '../../utils';
import {Col, Row } from 'react-bootstrap';
import Layout from '../../components/Layout';    
import Portlet from '../../components/Portlet';
import LoadingPage from '../../components/Layout/LoadingPage'; 
import PaginationList from '../../components/PaginationList';
import {setProjectDetail, setUserList, setSubmissionList} from '../../actions/ecommerce';
import {ToastContainer} from 'react-toastr';
import '../../assets/css/toastr.css';

const getListUser =(data=>{
	return Object.keys(data).map(index=>{		
		return (<div className="m-widget4__item" key={index}>															
					<div className="m-widget4__info">
						<span className="m-widget4__title">
							{data[index].username}
						</span>
					</div>
				</div>);
	})	
}) 

const getListSubmition =(data=>{
	return Object.keys(data).map(index=>{		
		return (<div className="m-widget4__item" key={index}>															
					<div className="m-widget4__info">
						<span className="m-widget4__title">
							{data[index].username}
						</span><br/>
						<span className="m-widget4__sub">
							{data[index].instance_id}
						</span>
					</div>
				</div>);
	})
})

const UnlimitedItem = ({type, t}) => (
	<div className="m-widget24__item">
		<h4 className="m-widget24__title">
			{type === "user" ? t('Number Of User') : t('Number Of Submission')}:
		</h4>
		<span className="h_unlimited">{t('Unlimited')}</span>
	</div>
)

export class ProjectDetail extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			id: window.location.href.split('/')[window.location.href.split('/').length - 1],
			showLoading: false,
			plan: {}
		}
	}

	componentDidMount(){
		const {id} = this.state,
		{t} = this.props
		let _this = this;
        this.setState({showLoading: true});

        // get project detail
        axios.get(apis.BASE_URL + 'projects/'+id+'/detail', utils.getConfig())
        .then( res => {
        	_this.props.dispatch(setProjectDetail(res.data.items))

        	// get plan info
            axios.get('https://rtcenter.org/services/ecommerce-plan/' + res.data.items.plan_name.replace('_trial', ''))
            .then( res => {
               _this.setState({
	                plan: res.data.msg[0]
	            });
            })
            .catch( error => console.log(error));

            // get data user
	        axios.get(apis.BASE_URL + 'projects/'+id+'/user/1/10/{"created_at":"SORT_ASC"}/[]', utils.getConfig())
	        .then( res => {
	        	_this.props.dispatch(setUserList({data:res.data.items, _meta: res.data._meta}))

	            // get data submision
		        axios.get(apis.BASE_URL + 'projects/'+id+'/submission/1/10/{"created_at":"SORT_ASC"}/[]', utils.getConfig())
		        .then( res => {
		        	_this.props.dispatch(setSubmissionList({data: res.data.items, _meta: res.data._meta}))
		            _this.setState({showLoading: false});
		        })
		        .catch( error => {
		            _this.refs.toastContainer.error(t("Cannot get user project"));
		            _this.setState({showLoading: false});
		            console.log(error);
		        });
	        })
	        .catch( error => {
	            _this.refs.toastContainer.error(t("Cannot get user project"));
	            _this.setState({showLoading: false});
	            console.log(error);
	        });
        })
        .catch( error => {
        	_this.props.dispatch(setProjectDetail({}))
            _this.setState({showLoading: false});
            _this.refs.toastContainer.error(t("Cannot get detail project"));
            console.log(error);
        });       
	}

	changeMetaUser(meta){
        const {id} = this.state,
        {t}= this.props
    	let _this = this
        // get data submision
        axios.get(apis.BASE_URL + 'projects/'+id+'/user/'+meta.currentPage+'/'+meta.perPage+'/{"created_at":"SORT_ASC"}/[]', utils.getConfig())
        .then( res => {
		    _this.props.dispatch(setUserList({data:res.data.items, _meta: res.data._meta}))
        })
        .catch( error => {
            _this.refs.toastContainer.error(t("Cannot get user project"));
            console.log(error);
        });
    }

    changeMetaSubmition(meta){
    	const {id} = this.state,
    	{t} = this.props
    	let _this = this
        // get data submision
        axios.get(apis.BASE_URL + 'projects/'+id+'/submission/'+meta.currentPage+'/'+meta.perPage+'/{"created_at":"SORT_ASC"}/[]', utils.getConfig())
        .then( res => {
        	_this.props.dispatch(setSubmissionList({data: res.data.items, _meta: res.data._meta}))
        })
        .catch( error => {
            _this.refs.toastContainer.error(t("Cannot get user project"));
            console.log(error);
        });
    }

	render(){
		const {t, userList, submissionList, projectDetail} = this.props
		let { plan, showLoading} = this.state
		let percent_user = (projectDetail.usage_user/projectDetail.max_user).toFixed(2)*100,
		percent_submition = (projectDetail.usage_submission/projectDetail.max_submission).toFixed(2)*100;
		return(
			<Layout> 
				{showLoading && <LoadingPage />}     
                <Layout.Content>
                    <Portlet>                                            
                        <Portlet.Title>
                            <Portlet.Caption>
                                <h3 className="m-portlet__head-text">{t("Project Detail")}</h3>                               
                            </Portlet.Caption>
                            <i className="project-detail">{t(projectDetail.phase)}</i>                             
                        </Portlet.Title>
                        <Portlet.Body> 
                        	<div className="row m-row--no-padding m-row--col-separator-xl">
								<div className="col-md-12 col-lg-6 col-xl-6 project-info row">
									<div className="col-xl-6 col-lg-12 col-md-6 col-sm-12 m-pricing-table__green-item">
										<div className="m-pricing-table__item m-pricing-table__active">
							                <div className="m-pricing-table__head">
							                    <h3 className="m-pricing-table__title">{plan.hasOwnProperty("content") && plan.content.hasOwnProperty("title") && plan.content.title}</h3>
							                    <div className="m-pricing-table__type">
							                        {plan.hasOwnProperty("content") && plan.content.hasOwnProperty("name") && plan.content.name}
							                    </div>
							                </div>
							                <div className="m-pricing-table__price">
							                    ${plan.hasOwnProperty("price") && plan.price !== "" && plan.price}
							                    <p>{t('monthly')}</p>
							                </div>
							                <div className="m-pricing-table__description">
							                    {plan.hasOwnProperty("content_html") && plan.content_html !== "" && ReactHtmlParser(plan.content_html)}                    
							                </div>
							            </div>
							        </div>
								</div>
								<div className="col-md-12 col-lg-6 col-xl-6">
									<div className="m-widget24">
									{projectDetail.max_user === '-1.0'?
										<UnlimitedItem type="user" t={t} />:
										<div className="m-widget24__item">
											<h4 className="m-widget24__title">{t('Number Of User')}</h4>
											<span className="m-widget24__stats m--font-brand"></span>
											<div className="m--space-10"></div>
											<div className="progress m-progress--sm">
												<div className="progress-bar m--bg-brand" role="progressbar" style={{width: ""+percent_user+"%"}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
											</div>
											<span className="m-widget24__number">
												{parseInt(projectDetail.usage_user)}/{parseInt(projectDetail.max_user)}
											</span>
										</div>
									}
									</div>
									<div className="m-widget24">
									{projectDetail.max_submission === '-1.0'?
										<UnlimitedItem type="submission" t={t} />:
										<div className="m-widget24__item">
											<h4 className="m-widget24__title">{t('Number Of Submission')}</h4>
											<span className="m-widget24__stats m--font-info"></span>
											<div className="m--space-10"></div>
											<div className="progress m-progress--sm">
												<div className="progress-bar m--bg-info" role="progressbar" style={{width :""+percent_submition+"%"}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
											</div>
											<span className="m-widget24__number">
												{parseInt(projectDetail.usage_submission)}/{parseInt(projectDetail.max_submission)}
											</span>
										</div>
									}
									</div>
								</div>     
							</div>
						</Portlet.Body>
                    </Portlet>
                    <Row>
						<Col className="col-xl-6 list-user">
							<Portlet>
								<Portlet.Title>
                            		<Portlet.Caption>
										<h3 className="m-portlet__head-text">{t('List Users')}</h3>
                            		</Portlet.Caption>
								</Portlet.Title>
								<Portlet.Body>
									<div className="tab-content">
										<div className="tab-pane active" id="m_widget4_tab1_content">
											<div className="m-widget4">	
												{Object.keys(userList.data).length === 0 ? null: getListUser(userList.data)}	
											</div>
										</div>
									</div>
									<hr/>
									<PaginationList t={t} meta={userList._meta} changeMeta={this.changeMetaUser.bind(this)}/>
								</Portlet.Body>
							</Portlet>
						</Col>
						<Col className="col-xl-6 list-submition">
							<Portlet >
								<Portlet.Title>
                            		<Portlet.Caption>
										<h3 className="m-portlet__head-text">{t('List Submission')}</h3>
                            		</Portlet.Caption>
								</Portlet.Title>
								<Portlet.Body>
									<div className="tab-content">
										<div className="tab-pane active" id="m_widget4_tab1_content">
											<div className="m-widget4">
												{Object.keys(submissionList.data).length === 0 ? null: getListSubmition(submissionList.data)}	
											</div>
										</div>
									</div>
									<hr/>
									<PaginationList t={t} meta={submissionList._meta} changeMeta={this.changeMetaSubmition.bind(this)} />
								</Portlet.Body>
							</Portlet>
						</Col>
					</Row>
                </Layout.Content>            
                <ToastContainer 
                    ref="toastContainer"
                    className="toast-top-right"
                />   
            </Layout>
			);
	}
}

export const mapStateToProps = ({ecommerce}) => {
    return {
            userList: ecommerce.userList,
            submissionList: ecommerce.submissionList,
            projectDetail: ecommerce.projectDetail,
        }
}

export default connect(mapStateToProps)(ProjectDetail)